class HighwayApiResponseModel {
  // #region Props

  // #endregion
  constructor({
    id,
    highway,
    code,
  }) {
    return {
      id,
      highway,
      code,
    };
  }
}

export default HighwayApiResponseModel;
